import { render, staticRenderFns } from "./CallDetailReport.vue?vue&type=template&id=e54ac41c"
import script from "./CallDetailReport.vue?vue&type=script&lang=js"
export * from "./CallDetailReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports